import { Heading, Text } from '@chakra-ui/layout';
import { Card, Container, Flex, ListItem, OrderedList, Link, Button } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC, ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

export const EmbedContentSection = () => {
  const { t } = useTranslation();

  return (
    <Container pt={{ base: 12 }}>
      <Flex maxW="800px" mx="auto" flexDir="column" gap={7}>
        <Heading fontSize="2xl">{t('lectureEmbed.grayHeading')}</Heading>
        <Text>{t('lectureEmbed.description.0')}</Text>
        <Text>{t('lectureEmbed.description.1')}</Text>
        <Card px={12} py={7}>
          <Heading fontSize="2xl">{t('lectureEmbed.instructionsHeading')}</Heading>
          <Text my={6}>{t('lectureEmbed.instructionsDescription')}</Text>
          <OrderedList listStyleType="none" ml={0} fontFamily="body">
            <ListItem fontWeight="bold">
              <Text as="span" mr={2}>
                1.
              </Text>
              {t('lectureEmbed.stepOne')}
            </ListItem>
            <ListItem>
              <Text as="span" fontWeight="bold" mr="2">
                2.
              </Text>

              <Trans
                i18nKey="lectureEmbed.stepTwo"
                components={{
                  htmlView: <Text as="span" fontWeight="bold" />,
                  pasteCode: <Text as="span" fontWeight="bold" />,
                }}
              />
            </ListItem>
            <ListItem>
              <Text as="span" fontWeight="bold" mr="2">
                3.
              </Text>
              {t('lectureEmbed.stepThree')}
            </ListItem>
          </OrderedList>

          <Text mt={6}>
            <Trans
              i18nKey="lectureEmbed.furtherAssistance"
              components={{
                contactUsLink: <ContactUsLink />,
              }}
            />
          </Text>
        </Card>
      </Flex>
    </Container>
  );
};

const ContactUsLink: FC<{ children?: ReactNode }> = ({ children }) => (
  <NextLink href="/contact-us/support">
    <Button variant="link">{children}</Button>
  </NextLink>
);
